export default {
    empty: 'Ce champ est obligatoire.',
		formSending: 'A problem came up while sending the form.',
    no_date_selected: 'Aucune date sélectionnée',
    no_file_selected: 'Aucun fichier choisi',
    pattern: 'Le champ [FIELD] est invalide.'
}